export const name = "CBRT";
export const summary = `Computes the cube root of \`X\`.`;
export const reference = `
## CBRT

Computes the cube root of \`X\`.

\`\`\`
CBRT(X)
\`\`\`

### Description

Computes the cube root of \`X\`. \`X\` can be any data type that coerces to \`FLOAT64\`. Supports the \`SAFE.\` prefix.

| X | CBRT(X) |
| --- | --- |
| \`+inf\` | \`inf\` |
| \`-inf\` | \`-inf\` |
| \`NaN\` | \`NaN\` |
| \`0\` | \`0\` |
| \`NULL\` | \`NULL\` |


### Return Data Type

\`FLOAT64\`


### Example



\`\`\`
SELECT CBRT(27) AS cube_root;

/*--------------------*
 | cube_root |
 +--------------------+
 | 3.0000000000000004 |
 *--------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
